import classNames from 'classnames';
import { formatCurrencyFromMicros } from '../constants';

export function SpendOverTimeChart({ daily = [] }) {
  const maxSpend = daily.reduce((max, point) => Math.max(max, point.spendMicros || 0), 0);

  return (
    <section className="rounded-2xl border border-mystic-500 bg-white p-5 shadow-sm">
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-lynch-500">Spend Over Time</p>
          <h2 className="mt-2 text-lg font-semibold text-black-pearl-500">Trailing performance</h2>
        </div>
      </div>
      {daily.length === 0 ? (
        <p className="mt-6 text-sm text-lynch-500">No daily metrics are available for the selected range yet.</p>
      ) : (
        <div className="mt-6 space-y-3">
          {daily.map((point) => {
            const width = maxSpend === 0 ? 0 : Math.max(6, Math.round((point.spendMicros / maxSpend) * 100));

            return (
              <div key={point.date} className="grid grid-cols-[96px_1fr_auto] items-center gap-3">
                <span className="text-sm text-lynch-500">{point.date}</span>
                <div className="h-3 rounded-full bg-solitude-500">
                  <div
                    className={classNames('h-3 rounded-full bg-[#00509D] transition-[width] duration-300', {
                      'min-w-[6px]': point.spendMicros > 0,
                    })}
                    style={{ width: `${width}%` }}
                  />
                </div>
                <span className="text-sm font-medium text-black-pearl-500">
                  {formatCurrencyFromMicros(point.spendMicros)}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}
